const isoDate = (value: Date): string => value.toLocaleDateString('en-CA');

const QUEUE_MONTHS = 3;

export function defaultDateFrom(): string {
  const today = new Date();
  return isoDate(new Date(today.getFullYear(), today.getMonth() - QUEUE_MONTHS, today.getDate()));
}

export function defaultDateTo(): string {
  return isoDate(new Date());
}

export function getQueueDefaultPeriod(): { dateFrom: string; dateTo: string } {
  return { dateFrom: defaultDateFrom(), dateTo: defaultDateTo() };
}
